import React from "react";
import { Button as AntdButton, ButtonProps } from "antd";
import classNames from "classnames";
import { tyButtonCls } from "./styled";

export const Button = (props: ButtonProps) => {
  return <AntdButton {...props} className={classNames(tyButtonCls, props.className)} />;
};

Object.assign(Button, AntdButton);
